<template>

    <div>
      
      <b-modal
      v-model="customerModal"
      centered 
      size="lg"
      hide-footer
    >
    <div class="row justify-content-center">
      <customer-wizard :customer-data="customerData" @modal-false="modalToggle"
      @refetch-data="refetchData" />
    </div>
    </b-modal>
  
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
  
      <div class="m-2">

        <!-- Table Top -->
        <b-row>

        <!-- Per Page -->
        <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
            <label>Show</label>
            <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
        </b-col>
        
        <!-- Search -->
        <b-col
            cols="12"
            md="6"
        >
            <div class="d-flex align-items-center justify-content-end">
            <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
            />
            <b-button
                variant="primary"
                @click="customerModal = true"
                v-if="isDeveloper"
            >
                <span class="text-nowrap">Müşteri Ekle</span>
            </b-button>
            
            </div>
        </b-col>
        </b-row>

        </div>
  
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchCustomers"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
        
        
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserVerify(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status ? 'Aktif' : 'Pasif' }}
          </b-badge>
        </template>
  
        <template #cell(created_date)="data">
          {{ formatDate(data.item.created_date) }}
        </template>

        <template #cell(show_details)="data">

        <!-- As `data.showDetails` is one-way, we call the toggleDetails function on @change -->
        <b-form-checkbox
        v-model="data.detailsShowing"
        @change="data.toggleDetails"
        >
        {{ data.detailsShowing ? 'DB Gizle' : 'DB Gör' }}
        </b-form-checkbox>
        </template>


      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <!-- <b-link @click="editCustomer(data.item)">
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">Düzenle</span>
        </b-link> -->
        <b-button
          variant="primary"
          :to="{ name: 'customer-card', params: { id: data.item.id } }"
        >
          <feather-icon icon="CreditCardIcon" />
          <span class="align-middle ml-50">Müşteri Kartı</span>
        </b-button>
      </template>


        <!-- full detail on click -->
      <template #row-details="data">
      <b-card class="border border-primary">

        <b-card-body
          class="invoice-padding pt-0"
        >
          <b-row class="invoice-spacing">
            
            <!-- Col: Payment Details -->
            <b-col
              xl="6"
              cols="12"
            >
              <div>
                <h6 class="mb-2">
                  {{ data.item.domain }} / Veritabanı Bilgileri:
                </h6>
                <p>
                  <b>Host:</b>
                  <span>{{ data.item.db_host }}</span>
                </p>
                <p>
                  <b>Veritabanı Adı:</b>
                  <span>{{ data.item.db_name }}</span>
                </p>
                <p>
                  <b>Kullanıcı adı:</b>
                  <span>{{ data.item.db_user }}</span>
                </p>
                <p>
                  <b>Şifre:</b>
                  <span>{{ data.item.db_pass }}</span>
                </p>
              </div>
            </b-col>

          </b-row>
        </b-card-body>
        
          <!--
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="data.toggleDetails"
          >
            Gizle
          </b-button>
        -->
      </b-card>
      </template>
  
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
  
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
  
              <b-pagination
                v-model="currentPage"
                :total-rows="totalCustomers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
  
            </b-col>
  
          </b-row>
        </div>
    </b-card>
  
    </div>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, VBTooltip
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import { avatarText } from '@core/utils/filter'
  import useCustomersList from '@/components/manage/useCustomersList'
  import CustomerWizard from '@/components/manage/CustomerWizard.vue'
  // Notification
  import { useToast } from 'vue-toastification/composition'
  
  export default {
    components: {
      
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BFormCheckbox,
      BTableLite,
  
      vSelect,

      CustomerWizard
    },
    directives: {
      'b-tooltip': VBTooltip
    },
    data() {
      return {
        customerModal: false,
        customerData:{}
      }
    },
    watch: {
      customerModal(newValue) {
        if(!newValue){
          this.customerData={}
          //this.$store.commit('user/LOGOUT_USER');
        }
      }
    },
    created(){
      //this.$store.commit('user/LOGOUT_USER');
    },
    methods: {
      editCustomer(item) {
        this.customerData=item
        this.modalToggle()
      },
      modalToggle(){
        this.customerModal=!this.customerModal
      }
    },
    setup() {
  
      const toast = useToast()
  
  
      const resolveUserVerify = verify => {
          if (verify == '0') return 'warning'
          if (verify == '1') return 'success'
          return 'primary'
      }
  
      const {
        fetchCustomers,
        tableColumns,
        perPage,
        currentPage,
        totalCustomers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
  
        // UI
        resolveUserRoleVariant,
        resolveUserRoleIcon,
        resolveEventstatusVariant,
  
      } = useCustomersList()
  
      return {

        resolveUserVerify,
  
        fetchCustomers,
        tableColumns,
        perPage,
        currentPage,
        totalCustomers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
  
        // Filter
        avatarText,
  
        // UI
        resolveUserRoleVariant,
        resolveUserRoleIcon,
        resolveEventstatusVariant,
  
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
  